<template>
    <el-color-picker
        :size="size"
        v-bind="attrs"
        v-on="listeners"
    />
</template>

<script setup lang="ts">
import { ColorPicker as ElColorPicker } from 'element-ui'
import { useAttrs, useListeners } from 'vue'

const listeners = useListeners()
const attrs = useAttrs()

withDefaults(
    defineProps<{
        size?: 'medium' | 'small' | 'mini'
    }>(),
    {
        size: 'small'
    }
)
</script>

